import { ComboBox, CountryFlag } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CountryComboBox = ({
  menuItems = [],
  label,
  value,
  handleChange,
  fullWidth,
  backgroundColor,
  error,
  helperText,
}) => {
  const menuItemsWithFlags = menuItems.map(item => ({
    ...item,
    label: (
      <Styles.CountryLabel>
        <CountryFlag code={item.value} /> {item.label}
      </Styles.CountryLabel>
    ),
  }))

  return (
    <ComboBox
      label={label}
      value={value}
      handleChange={handleChange}
      menuItems={menuItemsWithFlags}
      backgroundColor={backgroundColor}
      fullWidth={fullWidth}
      error={error}
      helperText={helperText}
    />
  )
}

export default CountryComboBox
